import React, { useEffect, useState } from 'react';
import { supabase } from '../lib/supabaseClient';
import '../styles/Modal.css';

function AgreementModal({ isOpen, onClose, agreement, onSuccess }) {
  const [formData, setFormData] = useState({
    id: '',
    title: '',
    en: '',
    tr: '',
    ru: '',
    active: true,
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (agreement) {
      setFormData({
        id: agreement.id || '',
        title: agreement.title || '',
        en: agreement.en || '',
        tr: agreement.tr || '',
        ru: agreement.ru || '',
        active: agreement.active !== undefined ? agreement.active : true,
      });
    } else {
      setFormData({
        id: '',
        title: '',
        en: '',
        tr: '',
        ru: '',
        active: true,
      });
    }
  }, [agreement]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      // Validate form data
      if (!formData.en || !formData.tr || !formData.ru) {
        setError('Lütfen tüm zorunlu alanları doldurun.');
        setLoading(false);
        return;
      }

      if (agreement) {
        // Update existing agreement
        const { error } = await supabase
          .from('agreements')
          .update({
            en: formData.en,
            tr: formData.tr,
            ru: formData.ru,
          })
          .eq('id', agreement.id);

        if (error) throw error;
      } else {
        // Insert new agreement
        const { error } = await supabase.from('agreements').insert([
          {
            en: formData.en,
            tr: formData.tr,
            ru: formData.ru,
          },
        ]);

        if (error) throw error;
      }

      onSuccess();
      onClose();
    } catch (error) {
      console.error('Error saving agreement:', error);
      setError('Sözleşme kaydedilirken bir hata oluştu.');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content max-w-4xl w-full bg-white rounded-lg shadow-xl overflow-hidden">
        <div className="modal-header bg-gray-50 border-b border-gray-200 px-6 py-4">
          <h2 className="text-xl font-semibold text-gray-800">
            {agreement ? 'Sözleşme Düzenle' : 'Yeni Sözleşme Ekle'}
          </h2>
          <button
            className="close-button text-gray-500 hover:text-gray-700 transition-colors"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <div className="modal-body p-6">
          {error && (
            <div className="error-message mb-6 p-4 bg-red-100 text-red-700 rounded-md border border-red-200">
              <p className="font-medium">{error}</p>
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-6 mb-6">
              <div className="form-group">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  İngilizce İçerik <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="en"
                  value={formData.en}
                  onChange={handleChange}
                  rows="6"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  placeholder="İngilizce içeriği girin"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 mb-6">
              <div className="form-group">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Türkçe İçerik <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="tr"
                  value={formData.tr}
                  onChange={handleChange}
                  rows="6"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Türkçe içeriği girin"
                  required
                />
              </div>
            </div>

            <div className="grid grid-cols-1 gap-6 mb-6">
              <div className="form-group">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Rusça İçerik <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="ru"
                  value={formData.ru}
                  onChange={handleChange}
                  rows="6"
                  className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
                  placeholder="Rusça içeriği girin"
                  required
                />
              </div>
            </div>

            <div className="form-group mb-8">
              <label className="inline-flex items-center">
                <input
                  type="checkbox"
                  name="active"
                  checked={formData.active}
                  onChange={handleChange}
                  className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                />
                <span className="ml-2 text-sm text-gray-700">Aktif</span>
              </label>
            </div>

            <div className="modal-footer flex justify-end space-x-3 pt-4 border-t border-gray-200">
              <button
                type="button"
                onClick={onClose}
                className="px-4 py-2 bg-white border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                disabled={loading}
              >
                İptal
              </button>
              <button
                type="submit"
                className="px-4 py-2 bg-blue-600 border border-transparent rounded-md text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                disabled={loading}
              >
                {loading ? (
                  <span className="flex items-center">
                    <svg
                      className="animate-spin -ml-1 mr-2 h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Kaydediliyor...
                  </span>
                ) : (
                  'Kaydet'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AgreementModal;
